export const bussdepType = [
  { key: '1', value: '保险' }
  // { key: '1', value: 'TD' },
  // { key: '2', value: '期货' },
  // { key: '3', value: '港美股' },
  // { key: '4', value: '投教' },
  // { key: '5', value: '保险' },
  // { key: '6', value: 'MCN' },
  // { key: '7', value: '营销助手' },
  // { key: '8', value: '投顾' },
  // { key: '9', value: '基金' },
  // { key: '10', value: '内部公共' },
  // { key: '11', value: '外部合作' },
  // { key: '12', value: '证券' },
  // { key: '13', value: '财商' },
]

export const filterBussdepType = (id) => {
    var str = ''
    bussdepType.forEach(item=>{
      if (item.key == id){
        str = item.value
      }
    })
    return str
}